/* @flow */

import React from 'react';
import t from 'app/utils/translate';
import classNames from 'classnames';

import TeamSelectButton from 'app/components/commons/TeamSelectButton';
import Fieldset from 'app/components/commons/Fieldset';
import Button from 'app/components/commons/Button';
import useSheet from 'app/jss';

type Props = {
  classes: Object,
  selectedTeams: Array<string>,
  games: Array<*>,
  teamIds: Array<string>,
  onTeamsChange: () => void
};

function TeamsFilter({ classes, selectedTeams, games, teamIds, onTeamsChange }: Props) {
  return (
    <div className={classes.content}>
      <div className={classes.contentInner}>
        <div className={classes.set}>
          <div className={classNames(classes.row, classes.row1)}>
            {teamIds.length > 0 ? (
              <Fieldset itemClassName={classes.gameButton} legend={t('Games')}>
                {games.map(game => (
                  <TeamSelectButton
                    key={game.name}
                    awayImage={game.awayImage}
                    awayTeamName={game.awayAbbr}
                    awayTeamId={game.awayId}
                    awayTeamSelected={selectedTeams.includes(game.awayId)}
                    countryCode={game.countryCode}
                    homeImage={game.homeImage}
                    homeTeamName={game.homeAbbr}
                    homeTeamId={game.homeId}
                    homeTeamSelected={selectedTeams.includes(game.homeId)}
                    onSelect={onTeamsChange}
                  />
                ))}
              </Fieldset>
            ) : (
              <p>Nothing to filter</p>
            )}
          </div>
          <div className={classNames(classes.row, classes.row2)}>
            <Button
              autoBorderRadius={false}
              kind="success"
              disabled={teamIds.length === selectedTeams.length}
              onClick={() => onTeamsChange(teamIds)}
            >
              Select All
            </Button>
            <Button
              autoBorderRadius={false}
              kind="danger"
              disabled={selectedTeams.length === 0}
              onClick={() => onTeamsChange([])}
            >
              Unselect All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

function applyStyles(theme) {
  return {
    content: {
      alignItems: 'flex-start',
      display: 'flex',
      paddingTop: 7,
      paddingBottom: 10
    },
    contentInner: {
      flexGrow: 1
    },
    labelButton: {
      flexBasis: 40
    },
    row: {
      display: 'flex',
      flexWrap: 'wrap',
      paddingLeft: 10,
      paddingRight: 10
    },
    row1: {
      flexGrow: 1
    },
    row2: {
      justifyContent: 'flex-end'
    },
    gameButton: {
      whiteSpace: 'nowrap',
      flexBasis: '33%',
      flexGrow: 0,
      flexShrink: 0
    },
    final: {
      display: 'flex',
      alignSelf: 'flex-end'
    },
    reset: {
      marginLeft: 'auto'
    },
    set: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    [theme.mediaQuery.tabletLandscapeAndUp]: {
      content: {
        fontSize: '0.75rem'
      },
      gameButton: {
        flexBasis: '25%'
      }
    },
    [theme.mediaQuery.desktopAndUp]: {
      content: {
        paddingLeft: 5,
        paddingRight: 5
      },
      gameButton: {
        flexBasis: '20%'
      }
    }
  };
}

export default useSheet(applyStyles)(TeamsFilter);
